import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StepperStep } from './stepper.model';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StepperComponent {
    public steps = input.required<StepperStep[]>();
    public validSteps = input<number[]>([]);
    public currentStepIndex = input<number>(0);
    public maxReachedStepIndex = input<number>(0);
    public selectedStep = output<number>();

    protected stepType(index: number): string | undefined {
        if (this.validSteps().includes(index) && this.maxReachedStepIndex() >= index) {
            return 'success';
        }
        return undefined;
    }
}
